import { colors } from '../../theme/variables'

export default function StatusCircle({ type = 'success', height = 8, width = 8 }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={colors[type]} className="bi bi-circle-fill mr-3" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="8" />
        </svg>
    )
}
